export enum ICPAnalysisMethod {
  PRODUCT_BASED = "product-based",
  CUSTOMER_LIST = "customer-list",
}

export enum ICPTab {
  DEFINITION = 0,
  ANALYSIS = 1,
}
